<template>
  <input
    class="bg-white border-0 rounded-lg py-2 px-4"
    ref="datepickerInput"
    placeholder="дд.мм.гггг"
    type="text"
    v-mask="'##.##.####'"
    readonly
  />
</template>

<script>
import AirDatepicker from 'air-datepicker';
import 'air-datepicker/air-datepicker.css';
import { adpLocaleFor } from '@/i18n/datepicker';

export default {
  data() {
    return {
      isMobile: false,
      datepickerInstance: null,
    }
  },
  mounted() {
    this.initAirDatepicker();
    this.checkScreenSize();
    window.addEventListener('resize', this.checkScreenSize);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.checkScreenSize);
  },
  watch: {
    '$i18n.locale'() {
      this.reinitWithLocale()
    }
  },
  methods: {
    initAirDatepicker() {
      this.datepickerInstance = new AirDatepicker(this.$refs.datepickerInput, {
        showOtherMonths: false,
        isMobile: window.screen.width < 600 ? true : false,
        locale: adpLocaleFor(this.$i18n.locale),
        onSelect: (selectedDate) => {
          this.$emit('date-selected', selectedDate);
          if (this.datepickerInstance) {
            this.datepickerInstance.hide();
          }
        }
      });
    },
    destroyAirDatepicker() {
      if (this.datepickerInstance) {
        this.datepickerInstance.destroy()
        this.datepickerInstance = null
      }
    },
    reinitWithLocale() {
      const currentValue = this.$refs.datepickerInput?.value || ''
      this.destroyAirDatepicker()
      this.initAirDatepicker()

      if (currentValue) this.$refs.datepickerInput.value = currentValue
    },
    checkScreenSize() {
      return this.isMobile = window.screen.width < 600;
    }
  },

};
</script>

<style>
.air-datepicker-body--day-name {
  color: black !important;
}

.air-datepicker-cell.-selected- {
  color: black !important;
  background: #cdecd2 !important;
  border: 2px solid #0c9722 !important;
}
</style>

<style scoped>
input:focus {
  outline: none;
}
</style>
